import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { FaqLink } from '../../../../components/faq-link';
import Link from '../../../../components/link';
import { getExternalLinks } from '../../../../helpers/external-links';
import { i18n } from '../../../../helpers/i18n';
import { countMetrika } from '../../../../helpers/metrika';
import { getFeedbackFormVisibility, setFeedbackFormVisibility } from '../../../settings';
import { SectionComponentType } from '../../types';
import { FeedbackForm } from '../feedback-form';
import classes from './help.css';

const HelpSection: SectionComponentType = () => {
    const isFeedbackFormVisible = useSelector(getFeedbackFormVisibility);
    const links = useSelector(getExternalLinks);
    const dispatch = useDispatch();
    const showFeedbackForm = () => {
        dispatch(setFeedbackFormVisibility(true));
    };

    useEffect(
        () => () => {
            dispatch(setFeedbackFormVisibility(false));
        },
        [dispatch]
    );
    return (
        <>
            <Link view="default" href={links.help} target="_blank" className={classes.Link}>
                {i18n('settings', 'help-and-support')}
            </Link>
            <Link view="default" onClick={showFeedbackForm} className={classes.Link}>
                {i18n('feedback', 'contact-support')}
            </Link>
            {isFeedbackFormVisible && <FeedbackForm />}
            <FaqLink onClick={() => countMetrika('main_screen', 'open_faq')} />
        </>
    );
};

export default HelpSection;
